import openErrorModal from "../Error/ErrorModal";
import Mediator from "../Utilities/Mediator";
import { updateServiceDisplayOrder } from "../HTTPRequests/ServiceRequests";
import SortElementsByDrag from "../Utilities/SortElementsByDrag";
import Loader from "../DomUtilities/Loader";
import { fetchServicesDisplayOrderModal } from "../HTTPRequests/ItemRequests";

export default class ServicesDisplayOrderModal {
	modalDiv: HTMLDivElement;
	itemId: string;

	constructor(itemId: string, icon: HTMLElement) {
		this.itemId = itemId;
		this.modalDiv = document.createElement("div");

		this.init(icon);
	}

	private init(icon: HTMLElement) {
		icon.onclick = (event: MouseEvent) => {
			event.stopPropagation();
			icon.classList.add('clicked');
			setTimeout(() => icon.classList.remove('clicked'), 200);
			Loader.show();
			this.openModal();
		}
	}

	private openModal() {
		fetchServicesDisplayOrderModal(this.itemId)
			.then((response: string) => {
				this.modalDiv.innerHTML = response;
				document.body.appendChild(this.modalDiv);
				this.addModalButtonsClickListeners();
				this.addDragListeners();
			}, () => { //backend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private addModalButtonsClickListeners() {
		const closeImage: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		const cancelButton: HTMLButtonElement = this.modalDiv.querySelector('button');
		const saveButton: HTMLButtonElement = this.modalDiv.querySelector('button + button');

		window.onclick = (event: MouseEvent) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}

		closeImage.onclick = () => {
			this.modalDiv.remove();
		}

		cancelButton.onclick = () => {
			this.modalDiv.remove();
		}

		saveButton.onclick = () => {
			Loader.show();
			this.saveDisplayOrder();
		}
	}

	private saveDisplayOrder() {
		const services: NodeListOf<HTMLDivElement> = this.modalDiv.querySelectorAll("ul#all-services > li");
		let numberOfTasks: number = 0;
		let numberOfCompletedTasks: number = 0;

		services.forEach((service, index) => {
			const serviceIndex: number = parseInt(service.dataset.serviceIndex);
			if (serviceIndex != index) {
				numberOfTasks++;
				updateServiceDisplayOrder(service.id, (index + 1))
					.then(() => {
						numberOfCompletedTasks++;
						if (numberOfCompletedTasks === numberOfTasks) {
							Mediator.emit("itemCrudOperationFinished");
						}
					}, () => { //backend error
						openErrorModal();
					}).catch(() => { //frontend error
						openErrorModal();
					}).finally(() => {
						Loader.hide();
						this.modalDiv.remove();
					});
			}
		});
		if (numberOfCompletedTasks === numberOfTasks) {
			Mediator.emit("itemCrudOperationFinished");
			this.modalDiv.remove();
			Loader.hide();
		}
	}

	private addDragListeners() {
		const servicesList = document.getElementById('all-services');
		new SortElementsByDrag(servicesList);
	}
}
